/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Hours_PlaceholderInputs */

const en_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours (hh)`)
};

const fr_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heures (hh)`)
};

const de_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stunden (hh)`)
};

const it_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ore (hh)`)
};

const ru_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы (чч)`)
};

const es_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas (hh)`)
};

const zh_cn2_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小时 (hh)`)
};

const ja_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間（hh）`)
};

const hi_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घंटे (hh)`)
};

const pt_pt2_subtitle_export_hours_placeholder = /** @type {(inputs: Subtitle_Export_Hours_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas (hh)`)
};

/**
* | output |
* | --- |
* | "Hours (hh)" |
*
* @param {Subtitle_Export_Hours_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_hours_placeholder = /** @type {((inputs?: Subtitle_Export_Hours_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Hours_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_hours_placeholder(inputs)
	if (locale === "de") return de_subtitle_export_hours_placeholder(inputs)
	if (locale === "it") return it_subtitle_export_hours_placeholder(inputs)
	if (locale === "ru") return ru_subtitle_export_hours_placeholder(inputs)
	if (locale === "es") return es_subtitle_export_hours_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_hours_placeholder(inputs)
	if (locale === "ja") return ja_subtitle_export_hours_placeholder(inputs)
	if (locale === "hi") return hi_subtitle_export_hours_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_hours_placeholder(inputs)
	return en_subtitle_export_hours_placeholder(inputs)
});